module.exports = "/assets/crane.png";